import React from 'react';
import { Link } from 'react-router-dom';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { styled } from '@mui/material/styles';
import { ClientGridT } from '../ClientsGrid/model';

const StyLink = styled(Link, {
    name: 'StyLink',
})(({ theme }) => ({
    color: theme.palette.primary.main,
    fontSize: '1.2em',
}));

function RouterLinkRenderer({ data }: CellRendererParams<ClientGridT>) {
    if (!data) return <></>;
    return <StyLink to={`/support/${data.bind}`}>{data.name}</StyLink>;
}

export default RouterLinkRenderer;
